import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';
import { Flex } from '@ui-library/flex';

type Size = 'small' | 'default';

const sizePadding: Record<Size, string> = {
  small: 'padding: 1px 8px;',
  default: 'padding: 4px 8px;',
};

const StyledFlex = styled(Flex)<{
  size?: Size;
  $bgColor: string;
  $hoverColor?: string;
  $borderColor?: string;
  $variant?: 'next';
}>`
  ${({ size = 'default' }) => sizePadding[size]}
  border-radius: ${({ $variant, theme }) =>
    $variant === 'next' ? `${theme.token.borderRadiusSM}px` : `${theme.token.borderRadiusXL}px`};
  background-color: ${(props) => props.$bgColor};
  width: fit-content;
  height: fit-content;
  ${({ $hoverColor }) => `&:hover {
    background: ${$hoverColor};
  }`}
  ${({ $borderColor }) => `border: .1px solid ${$borderColor};`}
`;

const BadgeSkeleton = styled(Skeleton.Button)`
  width: 120px !important;
  height: ${({ size = 'default' }) => (size === 'default' ? '28px' : '22px')} !important;
`;

export const Badge = ({
  label,
  icon,
  bgColor,
  onClick,
  hoverColor,
  borderColor,
  className,
  testId,
  size = 'default',
  loading = false,
  variant,
}: {
  icon?: JSX.Element;
  bgColor: string;
  label: JSX.Element;
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  hoverColor?: string;
  borderColor?: string;
  className?: string;
  testId?: string;
  size?: Size;
  loading?: boolean;
  variant?: 'next';
}) =>
  loading ? (
    <BadgeSkeleton size={size} active shape={variant ? 'square' : 'round'} />
  ) : (
    <StyledFlex
      size={size}
      gap="0.25rem"
      className={className}
      alignItemsCenter
      $bgColor={bgColor}
      onClick={onClick}
      $hoverColor={hoverColor}
      $borderColor={borderColor}
      $variant={variant}
      data-testid={testId}
    >
      {icon}
      {label}
    </StyledFlex>
  );
